import { UPDATE_FEIERTAGSKONTO_UEBERTRAG_AUS_VORJAHR } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useUpdateUebertragAusVorjahr/graphql/mutation';
import { Mitarbeiter_UpdateFeiertagskontoUebertragAusVorjahrMutationVariables } from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateUebertragAusVorjahr() {
  const [update, result] = useMutation(
    UPDATE_FEIERTAGSKONTO_UEBERTRAG_AUS_VORJAHR,
    {
      refetchQueries: ['mitarbeiter_getFeiertagskonto'],
      awaitRefetchQueries: true,
    },
  );
  const updateUebertragsAusVorjahr = useCallback(
    (
      variables: Mitarbeiter_UpdateFeiertagskontoUebertragAusVorjahrMutationVariables,
    ) => {
      return update({ variables });
    },
    [update],
  );
  if (!result) {
    throw new Error('Fehler beim updaten des Übertrags aus dem Vorjahr. s');
  }
  return [updateUebertragsAusVorjahr, result] as const;
}
